/*
 * @Author: TinaHuang0183
 * @Date: 2022-07-18 14:16:55
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-17 09:23:46
 * @FilePath: /notion-widgets-site/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import App from "./App.vue";
import "./plugins/element.js";
import router from "./router";
import "lib-flexible/flexible";
import "./less/app.less";
import VueClipboard from "vue-clipboard2";
import axios from "axios";
// import 'gitalk/dist/gitalk.css'
// import Gitalk from 'gitalk'
import Crypto from "./plugins/crypto";
import Code from "./lib/CodeDialog";
import BindDialog from "./lib/BindDialog";
import * as custom from "./filters";
// 国际化
// import VueI18n from 'vue-i18n'
// console.log(VueI18n)
// Vue.use(VueI18n) // 通过插件的形式挂载

import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
Vue.component(CollapseTransition.name, CollapseTransition);

let _axios = axios.create({ withCredentials: true });
_axios.interceptors.request.use(
  (config) => {
    // config.headers['"User-Agent'] = 'httishere'
    // config.headers['Authorization'] = 'Bearer eyJ0eXBlIjoiSldUIiwiYWxnIjoiMjFkZWQ1Y2I1ZmY2YmEzNDA0MWQ3NDRiMTkzY2YzOWYifQ==.eyJleHAiOjE2MTAwMDc4NzIzNzIsImF2YWlsYWJsZSI6NDMyMDAwMDAwLCJodHRpc2hlcmUvaXNfcm9vdCI6dHJ1ZX0=';
    config.headers["X-Auth-Token"] = "8Bw0MWHoOQwNR1g1O8OtyLz5P0wyFnj8rkqlmOcD";
    return config;
  },
  (err) => {
    return Promise.error(err);
  }
);

Vue.use(VueClipboard);
Vue.prototype.$axios = _axios;
Vue.prototype.$global_path =
  process.env.NODE_ENV === "production"
    ? window.location.origin + "/widgets-site"
    : window.location.origin;

Vue.config.productionTip = false;

const token_code = "5db61da427f33cbbf183509cf1c79896"; // 32位加密(小)

const admin_token = "145034fbc3e4cdc28b54f1e7460da006"; // htt0728

Vue.prototype.$token = token_code;
Vue.prototype.$admin = admin_token;

Vue.prototype.$crypto = Crypto;

Vue.prototype.$code = Code.install;

// 导出的是对象，可以直接通过 key 和 value 来获得过滤器的名和过滤器的方法
Object.keys(custom["default"]).forEach((key) => {
  Vue.filter(key, custom["default"][key]);
});

const whiteList = [
  "code",
  "index",
  "log",
  "lib",
  "reward",
  "lib",
  "time",
  "eff",
  "others",
  "picks",
  "paid",
  "pro",
  "news",
  "mbase",
  "mindex",
  "mwids",
  "mpro",
  "mpicks",
  "mlink",
  "picks_get",
  "mpicks_get"
];

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  if (!whiteList.includes(to.name)) {
    // 需要验证口令
    let code = localStorage.getItem("token");
    if (code && (code === token_code || code === admin_token)) next();
    else {
      Code.install({
        successGo() {
          next();
        },
      });
      next(false);
    }
  } else if(to.name === 'vip-box') {
    if(!localStorage.user) BindDialog.install(
      {successGo() {
        next();
      },}
    )
  } else next();
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
